import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"

export type HuAvatarCardSidebarSkeletonProps = {
  topContent?: React.JSX.Element
  className?: string
} & React.ComponentProps<"div">

export function HuAvatarCardSidebarSkeleton({ topContent, className, ...props }: HuAvatarCardSidebarSkeletonProps) {
  return (
    <div
      className={cn(
        "relative flex h-61 w-full flex-col items-center justify-center rounded-b-3xl bg-surface-foreground",
        className,
      )}
      {...props}
    >
      {/* TOP CONTENT */}
      {topContent}

      <div className="flex w-full flex-row items-center justify-center gap-3 pt-6">
        <div className="flex">
          <Skeleton className="mb-1 size-22 rounded-full" />
        </div>
        <div className="flex flex-col items-center justify-center gap-1">
          <Skeleton className="h-9 w-45 rounded-md" />
          <Skeleton className="h-5 w-30 rounded-md" />
        </div>
      </div>

      <div className="absolute right-0 mt-12 mr-3 flex flex-col gap-1">
        <Skeleton className="size-8 rounded-full p-2" />
        <Skeleton className="size-8 rounded-full p-2" />
      </div>
    </div>
  )
}
